// Shared fallbacks for the room create/edit forms. Used when
// GET /rooms/config is unavailable so the dropdowns never render empty.
// Mirrors models/enums.py FloorLevel / RoomType — keep in sync if the
// enums change. (Extracted so AddRoom and RoomEdit can't drift: RoomEdit
// previously had no fallback and showed an empty floor dropdown on
// config failure.)

export const FALLBACK_FLOOR_LEVELS = [
    { value: 'Basement', label: 'Basement' },
    { value: '1st Floor', label: '1st Floor' },
    { value: '2nd Floor', label: '2nd Floor' },
    { value: 'Attic', label: 'Attic' },
    { value: 'Outdoor', label: 'Outdoor' },
];

export const FALLBACK_ROOM_TYPES = [
    { value: 'living_room', label: 'Living Room' },
    { value: 'bedroom', label: 'Bedroom' },
    { value: 'kitchen', label: 'Kitchen' },
    { value: 'bathroom', label: 'Bathroom' },
    { value: 'dining_room', label: 'Dining Room' },
    { value: 'office', label: 'Office' },
    { value: 'laundry', label: 'Laundry' },
    { value: 'garage', label: 'Garage' },
    { value: 'basement', label: 'Basement' },
    { value: 'attic', label: 'Attic' },
    { value: 'hallway', label: 'Hallway' },
    { value: 'outdoor', label: 'Outdoor' },
    { value: 'other', label: 'Other' },
];

// Custom-property keys that collide with dedicated fields. `notes` has its
// own textarea; `dimensions` is a retired key the custom-properties list
// filters out (a prop with that name would be invisible and unremovable).
export const RESERVED_PROPERTY_KEYS = ['notes', 'dimensions'];

// Single source for the guard so AddRoom/RoomEdit can't drift and the
// message stays correct if RESERVED_PROPERTY_KEYS ever grows beyond two
// entries. Returns the user-facing error for a reserved key, or null.
export const reservedPropertyKeyError = (key) => {
    const k = (key || '').trim().toLowerCase();
    if (!RESERVED_PROPERTY_KEYS.includes(k)) return null;
    return k === 'notes'
        ? 'Use the dedicated field above for notes'
        : `"${k}" is a reserved field and can't be used as a custom property`;
};
